import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import React, { useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch } from "react-redux";
import { alertFailure, alertSuccess } from "../../../store/actions/alert";
import moment from "moment";
import { DatePicker } from "antd";
import useStyles from "./style";
import CustomButton from "./Button";
import { apiRoute, convertToTransaction, SendSolanaTransaction } from "../../../utils";
import { BaseRequest } from "../../../request/Request";

export default function CloseTime({
  vaultAddress,
  pool_index,
  poolId,
  multiSigWallet,
  isValidVault,
  currentOpenTime,
  owner,
  disableButton
}: any) {
  const dispatch = useDispatch();

  const [closeTime, setCloseDate] = useState<any>();
  const [loading, setLoading] = useState<any>(false);

  const setCloseTime = async () => {
    if (!window?.solana?.publicKey) {
      dispatch(alertFailure("Please Connect Solana Wallet"));
      return;
    }
    if(!pool_index) {
      dispatch(alertFailure("Pool is not deployed"))
      return;
    }
    if (!multiSigWallet) {
      dispatch(alertFailure("Please Enter MultiSig Wallet Address"));
      return;
    }
    if (!vaultAddress) {
      dispatch(alertFailure("Please Enter Vault Address"));
      return;
    }
    if(owner && !isValidVault) {
      dispatch(alertFailure("Vault Address should be the owner of Pool"));
      return;
    }
    if(!closeTime) {
      dispatch(alertFailure("Please Select Close Time"));
      return;
    }
    const now = moment();

    if (!moment(closeTime).isSameOrAfter(now)) {
      dispatch(alertFailure("Close Time must be greater than or equal to Current Time"));
      return;
    }

    if(moment(closeTime).unix() <= currentOpenTime.toString()) {
      dispatch(alertFailure("Close Time must be greater than Start Time"));
      return;
    }
  
    try {
      setLoading(true)
      const squads_multi_sig_address = multiSigWallet;
      const baseRequest = new BaseRequest();
        let url = apiRoute(`/solana-multisig/set-close-time`);
        const body = {
          squads_multi_sig_address: squads_multi_sig_address, 
          campaign_id: poolId, 
          close_time: moment(closeTime).unix(),
          fee_payer: window?.solana?.publicKey.toString()
      }
        const response = (await baseRequest.post(url, body)) as any;
        const result = await response.json();
        const data = result.data;
        const tx = await convertToTransaction(data)
      const sig = await SendSolanaTransaction(tx);
      dispatch(alertSuccess("Transaction Successfull"));
      setLoading(false);
    } catch (error) {
      dispatch(alertFailure("Transaction failed"));
      setLoading(false);
    }
  };

  const classes = useStyles();
  return (
    <div className={classes.spaceAbove}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Set Close Time
        </AccordionSummary>
        <AccordionDetails>
          <div className={classes.columnFlex}>
            <label className={classes.formControlLabel}>Close Time</label>
            <br />
            <DatePicker
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{
                defaultValue: moment("00:00:00", "HH:mm:ss"),
                format: "HH:mm",
              }}
              disabled = {disableButton}
              onSelect={(datetimeSelected: any) => {
                setCloseDate(datetimeSelected);
              }}
              minuteStep={15}
              style={{
                marginBottom: "20px",
              }}
            />
            <br />
            <CustomButton disableButton = {disableButton} onClick={setCloseTime} />
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
